import React from 'react';
import PropTypes from 'prop-types';
import Text, { TEXT_COLOR, TEXT_SIZE } from '@/bit/components/components.text';
import ProductPriceItem, {
  productPriceItemTypes,
} from '@/components/productPriceItem';

function ShoppingCartSummary({
  totalOneTimePrice,
  totalRecurringPrice,
  isTaxChanged,
  taxShortName,
}) {
  const {
    name: totalOneTimePriceName,
    finalPrice: totalOneTimePriceFinalPrice,
    quote: totalOneTimePriceQuote,
    currency: totalOneTimePriceCurrency,
  } = { ...totalOneTimePrice };
  const {
    promoted: totalRecurringPricePromote,
    name: totalRecurringPricePromoteName,
    finalPrice: totalRecurringPriceFinalPrice,
    promotionText: totalRecurringPricePromotionText,
    priceBeforeDiscount: totalRecurringPriceBeforeDiscount,
    quote: totalRecurringPriceQuote,
    currency: totalRecurringPriceCurrency,
    asterisk: totalRecurringPriceAsterisk,
  } = { ...totalRecurringPrice };

  return (
    <div>
      {totalOneTimePrice && (
        <ProductPriceItem
          className="shopping-cart__product-price-item"
          name={totalOneTimePriceName}
          price={totalOneTimePriceFinalPrice}
          priceQuote={totalOneTimePriceQuote}
          priceCurrency={totalOneTimePriceCurrency}
          type={productPriceItemTypes.summaryOneTimePrice}
        />
      )}
      <ProductPriceItem
        name={totalRecurringPricePromoteName}
        price={totalRecurringPriceFinalPrice}
        priceQuote={totalRecurringPriceQuote}
        asterisk={totalRecurringPriceAsterisk}
        priceCurrency={totalRecurringPriceCurrency}
        promoted={totalRecurringPricePromote}
        promotionText={totalRecurringPricePromotionText}
        promotionPrice={totalRecurringPriceBeforeDiscount}
        type={productPriceItemTypes.summaryRecurringPrice}
        description={`Todos los precios con ${taxShortName} incluido`}
      />
      {isTaxChanged && (
        <Text
          className="shopping-cart__text"
          text="Se han actualizado los impuestos aplicados"
          color={TEXT_COLOR.BLUE_DARK}
          size={TEXT_SIZE.CAPTION2}
        />
      )}

      <style jsx>
        {`
          :global(.shopping-cart__product-price-item) {
            margin-bottom: 8px;
          }
          :global(.shopping-cart__text) {
            margin-top: 8px;
          }
          :global(.shopping-cart__text-link) {
            margin-top: 8px;
            display: inline;
          }
          :global(.shopping-cart__link) {
            display: contents;
          }
        `}
      </style>
    </div>
  );
}
ShoppingCartSummary.propTypes = {
  totalRecurringPrice: PropTypes.shape({
    name: PropTypes.string,
    price: PropTypes.number,
    promoted: PropTypes.bool,
    promotionText: PropTypes.string,
    promotionPrice: PropTypes.number,
  }),
  totalOneTimePrice: PropTypes.shape({
    name: PropTypes.string,
    price: PropTypes.number,
    promoted: PropTypes.bool,
  }),
  isTaxChanged: PropTypes.bool,
  taxShortName: PropTypes.string,
};

ShoppingCartSummary.defaultProps = {
  totalRecurringPrice: {},
  totalOneTimePrice: [],
  isTaxChanged: false,
  taxShortName: '',
};
export default ShoppingCartSummary;
